export class Conceptualization {
  public conceptualizationCarouselItems: Array<{ title: string; categories: Array<string>, active?: boolean }> = [
    {
      title: 'Video',
      categories: [],
      active: true
    }, {
      title: 'Print',
      categories: []
    }, {
      title: 'Online',
      categories: []
    }, {
      title: 'Mobile',
      categories: []
    }, {
      title: 'Social',
      categories: []
    }, {
      title: 'Out-of-home',
      categories: []
    }, {
      title: 'Event marketing',
      categories: []
    }, {
      title: 'Experiences',
      categories: []
    }, {
      title: 'Direct and digital',
      categories: []
    }, {
      title: 'Corporate identity',
      categories: []
    }, {
      title: 'Collateral design',
      categories: []
    }, {
      title: 'Product design',
      categories: []
    }
  ];
}